import React from "react";
import clsx from "clsx";

const HierarchyFilterTab = ({
  tabList,
  selectedHierarchy,
  onHierarchySelection,
}) => {
  return (
    <div className="hierarchy-filter-tab">
      {tabList.map((hierarchy) => (
        <div
          key={hierarchy.id}
          onClick={() => onHierarchySelection(hierarchy.value)}
          className={clsx(
            "hierarchy-option",
            selectedHierarchy === hierarchy.value && "active"
          )}
        >
          <img
            src={
              selectedHierarchy === hierarchy.value
                ? hierarchy.selectedIcon
                : hierarchy.icon
            }
            alt={hierarchy.label}
            className="hierarchy-icon"
          />
          <span>{hierarchy.label}</span>
        </div>
      ))}
    </div>
  );
};

export default HierarchyFilterTab;
